function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComplete = function SvgComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "complete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fill-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 33.75C26.5306 33.75 33.75 26.5306 33.75 17.625C33.75 8.71941 26.5306 1.5 17.625 1.5C8.71941 1.5 1.5 8.71941 1.5 17.625C1.5 26.5306 8.71941 33.75 17.625 33.75Z",
    fill: "#2BC275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fill-foreground",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7823 12.4831C24.254 12.8875 24.3087 13.5977 23.9043 14.0694L16.7684 22.3947C16.5683 22.6281 16.2814 22.7695 15.9743 22.7859C15.6673 22.8024 15.3669 22.6924 15.1431 22.4817L11.5255 19.0759C11.0732 18.65 11.0517 17.938 11.4776 17.4856C11.9035 17.0332 12.6155 17.0118 13.0679 17.4377L15.8272 20.0355L22.196 12.6051C22.6003 12.1334 23.3106 12.0788 23.7823 12.4831Z",
    fill: "black"
  })));
};
SvgComplete.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgComplete"
};
export default SvgComplete;